import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1920,1518.81271 L1920,1744.69506 L112.941176,1744.69506 L112.941176,1518.81271 L1920,1518.81271 Z M1920,1066.93506 L1920,1292.93035 L112.941176,1292.93035 L112.941176,1066.93506 L1920,1066.93506 Z M282.375529,112.954824 L811.843765,502.376 L282.375529,891.684235 L282.375529,615.317176 L0.0225882353,615.317176 L0.0225882353,389.434824 L282.375529,389.434824 L282.375529,112.954824 Z M1920,615.283294 L1920,841.165647 L903.529412,841.165647 L903.529412,615.283294 L1920,615.283294 Z M1920,163.405647 L1920,389.400941 L903.529412,389.400941 L903.529412,163.405647 L1920,163.405647 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconIndentSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconIndentSolid, _Component);

  var _super = _createSuper(IconIndentSolid);

  function IconIndentSolid() {
    _classCallCheck(this, IconIndentSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconIndentSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconIndent",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconIndentSolid.displayName = "IconIndentSolid";
  return IconIndentSolid;
}(Component);

IconIndentSolid.glyphName = 'indent';
IconIndentSolid.variant = 'Solid';
IconIndentSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconIndentSolid;
export { IconIndentSolid };